document.addEventListener("DOMContentLoaded", function () {
  // Check if we're on the patislove-enjoy template
  const isPatisloveEnjoy = document.body.classList.contains(
    "template-patislove-enjoy"
  );
  if (!isPatisloveEnjoy) return;

  // Create chocolate elements with static URLs
  const chocolates = [
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_PEANUT_BUTTER_FRONT_1_6d75e844-4b41-4194-be93-3c435fb1e7c3.png?v=1746775238",
      class: "chocolate-1",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_7PEANUT_BUTTER_FRONT.png?v=1746775238",
      class: "chocolate-2",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_5PEANUT_BUTTER_FRONT_b20cfbb6-7050-47b9-ab76-f8969c8850b8.png?v=1746775238",
      class: "chocolate-3",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_PEANUT_BUTTER_FRONT_5e8b5519-21c9-4d7f-b66d-1c9a070291c5.png?v=1746775238",
      class: "chocolate-4",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_2PEANUT_BUTTER_FRONT_63035a76-7084-4a63-ba24-1b1fd0dac462.png?v=1746775238",
      class: "chocolate-5",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_4PEANUT_BUTTER_FRONT_eb660f29-9646-4758-a201-cf716812e3e1.png?v=1746775238",
      class: "chocolate-6",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_6PEANUT_BUTTER_FRONT_6ce4f4cd-9c37-4d3b-92e8-4355eebaf82b.png?v=1746775238",
      class: "chocolate-7",
    },
    {
      src: "https://cdn.shopify.com/s/files/1/0636/7471/2220/files/CHOCO_CANDY_6PEANUT_BUTTER_FRONT_6ce4f4cd-9c37-4d3b-92e8-4355eebaf82b.png?v=1746775238",
      class: "chocolate-8",
    },
  ];

  // Create a container for chocolates
  const chocolateContainer = document.createElement("div");
  chocolateContainer.className = "chocolate-container";
  document.body.appendChild(chocolateContainer);

  chocolates.forEach((choco) => {
    const element = document.createElement("div");
    element.className = `floating-chocolate ${choco.class}`;
    element.innerHTML = `<img src="${choco.src}" alt="Floating Chocolate">`;
    chocolateContainer.appendChild(element);
  });

  // Parallax effect
  const floatingElements = document.querySelectorAll(".floating-chocolate");

  function updateChocolatePositions() {
    const scrollPosition = window.scrollY;

    floatingElements.forEach((element, index) => {
      const speed = 0.1 + index * 0.05;
      const yPos = scrollPosition * speed;
      const rotate = (scrollPosition * 0.05) % 360;

      element.style.transform = `translateY(${yPos}px) rotate(${rotate}deg)`;
    });
  }

  window.addEventListener("scroll", updateChocolatePositions);
  window.addEventListener("resize", updateChocolatePositions);
  updateChocolatePositions(); // Initial position
});
